import { API } from '@/config';

import { FILL_DETAILS } from './mutations-types';

export default {
  async getDetails({ commit }, project) {
    const params = { project };
    const { record, total } = (await API.get('project/ivrBasicMessage/getIvrMessages', { params })).data.data;
    commit(FILL_DETAILS, { record, total });
  },

  async updateIvrMessages(context, params) {
    try {
      await API.patch('project/ivrBasicMessage/updateIvrMessages', { ...params });
    } catch (err) {
      console.log(err);
    }
  },

  // eslint-disable-next-line consistent-return
  async regenerateSelectedIvrMessages(context, params) {
    try {
      const details = (await API.patch('project/ivrBasicMessage/regenerateSelectedIvrMessages', { ...params })).data.data;
      return details;
    } catch (err) {
      console.log(err);
    }
  },
};
